import React from "react";
import { Link } from 'react-router-dom';
import { ReactComponent as WhatsappIcon } from '../svgs/whatsappicon.svg';

function WhatsappIconSVG(props) {
  return(
    <div className="WhatsappIcon">
        <a href={"https://wa.me/" + props.waNumber} target="_blank"><WhatsappIcon/></a>
    </div>
  );
}
export default WhatsappIconSVG;